<template>
  <div>
    <!-- <h2 class="text-center colorblue">Мои сотрудники</h2> -->
    <v-card>
      <v-data-table
        :headers="headers"
        :items="filtredItems"
        :items-per-page.sync="itemPerPage"
        :sort-by.sync="sort"
        :sort-desc.sync="sortDesc"
        :custom-sort="customSort"
        dense
        class="elevation-1"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <!-- <v-divider class="mx-4" inset vertical></v-divider> -->
            <!-- <v-spacer></v-spacer> -->
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Найти"
              single-line
              hide-details
            ></v-text-field>
            <v-spacer></v-spacer>
            <v-btn
              class="mb-2"
              @click="AddOrganisationUser"
              v-if="checkRole(roleObj.fiexpertAdmin)"
            >
              <v-icon left>add</v-icon>Добавить сотрудника
            </v-btn>
            <v-spacer></v-spacer>
          </v-toolbar>
        </template>

        <template v-slot:item.action="{ item }" v-if="checkRole(roleObj.fiexpertAdmin)">
          <v-icon color="primary" small class="mr-2" @click="editItem(item)"
            >edit</v-icon
          >
          <v-icon
            small
            class="mr-2"
            @click="removeUser(item)"
            title="Удалить пользователя"
            >delete</v-icon
          >
          <v-icon
            small
            @click="recoverByEmail(item.email)"
            title="Отправить восстановление пароля"
            >mail</v-icon
          >
        </template>
      </v-data-table>
    </v-card>
    <AddUser v-model="dialog2" @close="close2()" />
    <EditUser
      v-model="dialog"
      @close="close()"
      :editedItem="editedItem"
      v-if="checkRole(roleObj.finexpertManager)"
    />
    <!-- :editedIndex="editedIndex" -->
    <DeleteUser
      v-model="removeModal"
      @close="removeModal = false"
      :userInfo="removeUserInfo"
      @save="deleteItem(removeUserId)"
      v-if="checkRole(roleObj.finexpertManager)"
    />
  </div>
</template>

<script>
import Globalrules from "@/components/api/rules.js";
import Swal from "sweetalert2";
import moment from "moment";
import AddUser from "@/components/AddUser";
import EditUser from "@/components/EditUser";
import DeleteUser from "@/components/DeleteUser";
import { roleObj } from "@/plugins/roles";

export default {
  components: { AddUser, EditUser, DeleteUser },
  data() {
    return {
      roleObj,
      rules: Globalrules,
      search: "",
      activeBtn: 2,
      showNav: true,
      valid: true,
      dialog: false,
      dialog2: false,
      removeModal: false,
      removeUserId: null,
      removeUserInfo: null,
      items: [],
      itemPerPage: 5,
      editedItem: {
        famil: "",
        name: "",
        otch: "",
        position: "",
        phone: "",
        phone_note: "",
        email: "",
        role: "",
      },
      editedIndex: -1,
      moment,
      sort: ["fio"],
      sortDesc: [false],
    };
  },

  // filters: {
  //   toBool(val) {
  //     if (val) return "Да";
  //     else return "Нет";
  //   },
  // },
  computed: {
    filtredItems() {
      if (this.search === "") {
        return this.items;
      } else {
        const reg = new RegExp(this.search, "i");
        return this.items.filter((item) => {
          if (
            reg.test(item.email) ||
            reg.test(item.fio) ||
            reg.test(item.name) ||
            reg.test(item.otch) ||
            reg.test(item.phone) ||
            reg.test(item.role) ||
            reg.test(item.famil) ||
            reg.test(item.profile_name)
          ) {
            return true;
          } else {
            return false;
          }
        });
      }
    },
    headers() {
      const adminHeader = [
        { text: "Фамилия Имя Отчество", value: "fio" },
        { text: "Почта", value: "email" },
        { text: "Роль", value: "role" },
        // { text: "Доступ к калькулятору", value: "calc" },
        { text: "Отзывы", value: "rates" },
        { text: "Добавлен", value: "added" },
        {
          text: "Активирован",
          value: "active",
        },
        // { text: "Доступ к реестру победителей", value: "reestr" },
        { text: "Действия", value: "action" },
      ];
      const managerHeader = [
        { text: "Фамилия Имя Отчество", value: "fio" },
        { text: "Почта", value: "email" },
        { text: "Роль", value: "role" },
        // { text: "Доступ к калькулятору", value: "calc" },
        { text: "Отзывы", value: "rates" },
        { text: "Активирован", value: "active" },
        // { text: "Доступ к реестру победителей", value: "reestr" },
      ];
      return this.checkRole(roleObj.finexpertAdmin) ? adminHeader : managerHeader;
    },
    // roles(){return this.getRoles()},
    calcCount() {
      return this.$store.getters.getCalcCount;
    },
  },

  methods: {
    customSort(items, index, desc) {
      let result = this.DeepCopy(items);
      if (index[0] === "added") {
        result = !desc[0]
          ? result.sort((a, b) => {
              if (moment(a.added).isAfter(b.added)) return 1;
              if (moment(a.added).isSame(b.added)) return 0;
              if (moment(a.added).isBefore(b.added)) return -1;
            })
          : result.sort((a, b) => {
              if (moment(a.added).isAfter(b.added)) return -1;
              if (moment(a.added).isSame(b.added)) return 0;
              if (moment(a.added).isBefore(b.added)) return 1;
            });
      }

      if (index[0] === "active") {
        result = !desc[0]
          ? result.sort((a, b) => {


              if (a.active === "Нет" && b.active !== "Нет") return 1;
              if (a.active !== "Нет" && b.active === "Нет") return -1;
              if (moment(a.active).isAfter(b.active)) return -1;
              if (moment(a.active).isBefore(b.active)) return 1;
              if (moment(a.active).isSame(b.active)) return 0;
              return 1
            })
          : result.sort((a, b) => {


              if (a.active === "Нет" && b.active !== "Нет") return -1;
              if (a.active !== "Нет" && b.active === "Нет") return 1;
              if (moment(a.active).isAfter(b.active)) return 1;
              if (moment(a.active).isBefore(b.active)) return -1;
              if (moment(a.active).isSame(b.active)) return 0;
              return -1
            });
      }

      if (index[0] === "rates") {
        result = !desc[0]
          ? result.sort((a, b) => a.rates - b.rates)
          : result.sort((a, b) => b.rates - a.rates);
      }

      if (index[0] === "role") {
        result = !desc[0]
          ? result.sort((a, b) => (a.role < b.role ? 1 : -1))
          : result.sort((a, b) => (a.role < b.role ? -1 : 1));
      }
      if (index[0] === "email") {
        result = !desc[0]
          ? result.sort((a, b) => (a.email < b.email ? 1 : -1))
          : result.sort((a, b) => (a.email < b.email ? -1 : 1));
      }
      if (index[0] === "fio") {
        result = !desc[0]
          ? result.sort((a, b) => (a.fio < b.fio ? 1 : -1))
          : result.sort((a, b) => (a.fio < b.fio ? -1 : 1));
      }

      return result;
    },
    deleteItem(id) {
      this.$store.dispatch("deleteAgentSorts", id).then(() => {
        this.items = this.$store.getters.getAgentFirmSorts;
        if (this.$store.getters.getErrorApi == "DELETEYOURSELF") {
          Swal.fire({
            icon: "warning",
            title: "Ошибка удаления",
            text: "Нельзя удалить самого себя.",
          });
          this.removeModal = false;
        } else {
          Swal.fire({
            icon: "success",
            title: "Удалено",
            text: "Удаление прошло успешно",
          });
          this.removeModal = false;
          this.close();
        }
      });
    },
    removeUser(item) {
      this.removeUserId = item.user_id;
      this.removeModal = true;
      this.removeUserInfo = item;
    },
    comeTo(name) {
      this.$router.push("/" + name);
    },
    async initialize() {
      await this.$store.dispatch("getAgentSorts");
      const items = this.$store.getters.getAgentFirmSorts;
      for (const item of items) {
        item.fio = `${item.famil} ${item.profile_name} ${item.otch}`;
        item.added = moment(item.created_at).format("DD.MM.YYYY");
        const act = moment(item.email_verified_at).format("DD.MM.YYYY")
        item.active =
          item.active == 1
            ? act === 'Invalid date' ? `${moment(item.created_at).format("DD.MM.YYYY")}` : act
            : "Нет";
        item.rates = item.commentsCount;
        item.calc = moment(this.calcCount.to_date).format("DD.MM.YYYY");
        item.role = this.getRoleName(item.role);
        item.reestr = moment().format("DD.MM.YYYY");
        this.items.push(item);
      }
    },

    AddOrganisationUser() {
      this.dialog2 = true;
    },

    editItem(item) {
      this.editedIndex = this.items.indexOf(item);

      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    close2() {
      this.items = [];
      this.dialog2 = false;
      this.initialize();
    },
    close() {
      this.items = [];
      this.dialog = false;
      this.initialize();
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
  },

  mounted() {
    this.setTitle("Мои сотрудники");
  },
  async created() {
    await this.initialize();
  },
};
</script>

<style lang="scss"></style>
